import React from "react";

// Column header cell. Matches the Figma table: #6E6C71, ~16px, Ubuntu Light,
// normal case (not uppercase).
const Th = ({ children, onClick, active, dir, align = "left" }) => (
  <th
    onClick={onClick}
    className={`px-4 py-3 font-light text-gray-700 ${onClick ? "cursor-pointer select-none" : ""} ${
      align === "right" ? "text-right" : "text-left"
    }`}
    style={{ fontSize: 16 }}>
    {children}
    {active && <span className="ml-1 text-gray-500">{dir === "asc" ? "▲" : "▼"}</span>}
  </th>
);

export default Th;
